export const deepMerge = (defaultObj, remoteObj) => {
  if (
    !remoteObj ||
    typeof remoteObj !== 'object' ||
    Array.isArray(remoteObj) ||
    Object.keys(remoteObj).length === 0
  ) {
    return defaultObj
  }

  const merged = { ...defaultObj }
  for (const key in remoteObj) {
    if (!Object.hasOwn(remoteObj, key)) continue
    const remoteValue = remoteObj[key]
    const defaultValue = defaultObj?.[key]

    if (
      remoteValue &&
      typeof remoteValue === 'object' &&
      !Array.isArray(remoteValue) &&
      defaultValue &&
      typeof defaultValue === 'object' &&
      !Array.isArray(defaultValue)
    ) {
      merged[key] = deepMerge(defaultValue, remoteValue)
    } else if (remoteValue !== undefined) {
      merged[key] = remoteValue
    }
  }
  return merged
}

export const unwrapIapCatalog = remoteIapCatalog => {
  if (!remoteIapCatalog || typeof remoteIapCatalog !== 'object') return {}
  if (remoteIapCatalog.paddle?.pro) return remoteIapCatalog.paddle.pro
  return remoteIapCatalog
}

export const resolvePriceId = (
  productKey,
  catalog,
  currentTier,
  fallbackTier = 't8',
) => {
  if (!productKey || !catalog?.[productKey]) return ''
  const tiers = catalog[productKey]
  if (currentTier && tiers[currentTier]) return tiers[currentTier]
  if (tiers[fallbackTier]) return tiers[fallbackTier]
  const anyPrice = Object.values(tiers).find(p => p)
  return anyPrice || ''
}

export const resolvePaywallVariant = (
  paywallStructure,
  iapCatalog,
  variantKey,
  currentTier,
  fallbackTier = 't8',
) => {
  const variant = paywallStructure?.[variantKey]
  if (!variant?.products) return []
  return variant.products.map(productKey => ({
    productKey,
    priceId: resolvePriceId(productKey, iapCatalog, currentTier, fallbackTier),
  }))
}

export const resolveDiscountId = (discountKey, iadCatalog) => {
  if (!discountKey || !iadCatalog) return ''
  return iadCatalog[discountKey] || ''
}

export const validatePaywallVariant = (variant, variantName = 'unknown') => {
  const warnings = []
  if (!variant?.products) {
    warnings.push(`Paywall variant '${variantName}' has no products array`)
    return warnings
  }
  const n = variant.products.length
  if (variant.discountIds && variant.discountIds.length !== n) {
    warnings.push(
      `Paywall variant '${variantName}': products has ${n} items but discountIds has ${variant.discountIds.length}`,
    )
  }
  if (variant.discountRates && variant.discountRates.length !== n) {
    warnings.push(
      `Paywall variant '${variantName}': products has ${n} items but discountRates has ${variant.discountRates.length}`,
    )
  }
  return warnings
}
